import { controller } from '/@/renderer/api/controller';

export const api = {
    controller,
};
